import axios, { AxiosInstance } from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
/** Raw backend origin (no `/api` suffix) — use for URLs whose path already
 * contains `/api/...` (e.g. OAuth `start_path` from the platform catalog). */
export const BACKEND_ORIGIN = BACKEND_URL;

const TOKEN_KEY = "socibaba_token";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string | null) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export const api: AxiosInstance = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers ?? {};
    (config.headers as any).Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Do not force redirect here; individual pages decide.
    }
    return Promise.reject(err);
  },
);

export function thumbUrl(mediaId: string, thumbId: string): string {
  const token = getToken() ?? "";
  return `${API_BASE}/media/${mediaId}/thumb/${thumbId}?auth=${encodeURIComponent(token)}`;
}
